import { useEffect, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react"; // Importing arrow icons
import { FaRuler, FaMapMarkerAlt, FaStar, FaTimes, FaHeart, FaFire } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom"; // If you're using React Router for routing
import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { FiStar, FiHeart } from "react-icons/fi";
import { addToCart } from "../../utils/cartUtils";
import axios from "axios";
import { addToWishlist, removeFromWishlist, getWishlistProducts } from "../../utils/wishlistUtils";
import { IoEyeSharp } from "react-icons/io5";
import { Helmet } from "react-helmet-async";


const ProductDetail0 = ({ data }) => {
  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const app_type_id = sessionStorage.getItem("app_type_id");
  const [activeSection, setActiveSection] = useState(null);
  const productsDetails = data["get_products_details"][0];
  const productImages = data["get_products_details"][0]["product_images"];
  const sizes = data["get_products_details"][0]["size"];
  const productSpecification = data["get_products_details"][0]["specification_details"];
  const avgRating = data["get_products_details"][0]["avg_rating"];
  const sizePrice = data["get_products_details"][0]["get_price_lists"];
  const colors = data["color_products_lists"];
  const [mainImage, setMainImage] = useState(productImages?.[0] || null);

  const [cartMessage, setCartMessage] = useState({ text: "", type: "" });
  const [isVibrating, setIsVibrating] = useState(false);
  const [wishlistMessage, setWishlistMessage] = useState({ text: "", type: "" });
  // New state for cross-selling products
  const [crossSellingProducts, setCrossSellingProducts] = useState([]);
  const [crossSellingLoading, setCrossSellingLoading] = useState(false);
  const [crossSellingStartIndex, setCrossSellingStartIndex] = useState(0);
  const [faqs, setFaqs] = useState([]);

  // Fetch cross-selling products
  useEffect(() => {
    const fetchCrossSellingProducts = async () => {
      const crossSellingIds = productsDetails.cross_selling_products
        ? productsDetails.cross_selling_products.split("|").filter((id) => id)
        : [];

      if (crossSellingIds.length === 0) {
        setCrossSellingProducts([]);
        return;
      }

      setCrossSellingLoading(true);
      try {
        const products = [];
        for (const product_auto_id of crossSellingIds) {
          const formData = new FormData();
          formData.append("admin_auto_id", admin_auto_id);
          formData.append("app_type_id", app_type_id);
          formData.append("user_auto_id", admin_auto_id);
          formData.append("product_auto_id", product_auto_id);
          formData.append("customer_auto_id", admin_auto_id);
          formData.append("sub_category_auto_id", admin_auto_id);

          const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/get_product_details`, {
            method: "POST",
            body: formData,
          });

          if (!response.ok) {
            console.error(`Failed to fetch product details for ID: ${product_auto_id}`);
            continue;
          }

          const responseData = await response.json();
          if (responseData?.get_products_details?.[0]) {
            products.push(responseData.get_products_details[0]);
          }
        }
        setCrossSellingProducts(products);
      } catch (error) {
        console.error("Error fetching cross-selling products:", error);
        setCrossSellingProducts([]);
      } finally {
        setCrossSellingLoading(false);
      }
    };

    if (productsDetails.cross_selling_products) {
      fetchCrossSellingProducts();
    }
  }, [productsDetails.cross_selling_products, admin_auto_id, app_type_id]);

  useEffect(() => {
    if (cartMessage.text) {
      const timer = setTimeout(() => {
        setCartMessage({ text: "", type: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [cartMessage.text]);

  useEffect(() => {
    const syncWishlistStatus = async () => {
      const token = sessionStorage.getItem("accessToken");
      if (!token || !productsDetails?.product_auto_id) {
        setWishlisted(false);
        return;
      }

      try {
        const wishlistArray = await getWishlistProducts();

        const isWishlisted = wishlistArray.some(
          (item) =>
            String(item.product_auto_id) ===
            String(productsDetails.product_auto_id)
        );

        setWishlisted(isWishlisted);
      } catch (error) {
        console.error("Wishlist sync error:", error);
      }
    };

    syncWishlistStatus();
  }, [productsDetails.product_auto_id]);


  useEffect(() => {
    if (wishlistMessage.text) {
      const timer = setTimeout(() => {
        setWishlistMessage({ text: "", type: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [wishlistMessage.text]);

  const [wishlisted, setWishlisted] = useState(false);


  const handleWishlistToggle = async (e) => {
    e.preventDefault();
    setIsVibrating(false);
    setWishlistMessage({ text: "", type: "" });
    try {
      if (wishlisted) {
        const res = await removeFromWishlist(productsDetails.product_auto_id);
        if (res?.status === 1) {
          setWishlisted(false);
        } else if (res?.triggerVibration) {
          setIsVibrating(true);
          setTimeout(() => setIsVibrating(false), 600);
          if (!sessionStorage.getItem("accessToken")) {
            setWishlistMessage({ text: "Please sign in to add to wishlist", type: "error" });
          }
        }
      } else {
        const res = await addToWishlist(productsDetails.product_auto_id);
        console.log("Add to wishlist response:", res);
        if (res?.status === "1") {
          setWishlisted(true);
        } else if (res?.triggerVibration) {
          setIsVibrating(true);
          setTimeout(() => setIsVibrating(false), 600);
          if (!sessionStorage.getItem("accessToken")) {
            setWishlistMessage({ text: "Please sign in to add to wishlist", type: "error" });
          }
        }
      }
    } catch (error) {
      console.error("Wishlist error:", error);
    }
  };


  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  const reviewsRef = useRef(null);
  const allProducts = data["get_similar_product_lists"]; // All products
  const [startIndex, setStartIndex] = useState(0);

  const [pincode, setPincode] = useState(
    sessionStorage.getItem("userPincode") || ""
  );
  const [message, setMessage] = useState("");
  const [messageColor, setMessageColor] = useState("");
  const [pincodeAvailable, setPincodeAvailable] = useState(false);
  const [loading, setLoading] = useState(false);


  // Determine the visible products based on startIndex
  const visibleProducts = allProducts.slice(startIndex, startIndex + 4);

  const [selectedSize, setSelectedSize] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(
    productsDetails.final_product_price
  );


  const [currentOffer, setCurrentOffer] = useState(
    productsDetails.offer_percentage
  );
  const [originalPrice, setOriginalPrice] = useState(
    productsDetails.product_price
  );
  const [selectedSizeId, setSelectedSizeId] = useState(null);
  const [selectedStock, setSelectedStock] = useState(null);
  const isAddToCartEnabled = pincodeAvailable && selectedSize && selectedStock > 0;



  const handleSizeSelect = (size, index) => {
    setSelectedSize(size.size_name);
    setSelectedSizeId(size.size_auto_id);
    setSelectedStock(parseInt(size.size_stock, 10));
    const selectedPrice = sizePrice[index];
    if (selectedPrice) {
      setCurrentPrice(selectedPrice.final_size_price);
      setOriginalPrice(selectedPrice.size_price);
      setCurrentOffer(selectedPrice.offer_percentage);
    }
  };

  const [chartImage, setChartImage] = useState(null);
  const [chartImage2, setChartImage2] = useState(null);
  const [showSizeChart, setShowSizeChart] = useState(false);
  const isCustomizable = data["get_products_details"][0]["Customizable"] === "Yes";
  const [themeColor, setThemeColor] = useState("#000000")
  const [themeIconColor, setThemeIconColor] = useState("#000000");
  const [webFont, setWebFont] = useState("");





  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setWebFont(parsedStyle.web_font);
    }
  }, []);

  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }



  // Function to format SKU to exactly 8 characters using only product_model_auto_id
  const formatSKU = (modelId) => {
    const rawSKU = modelId ? modelId.toString() : '';
    if (rawSKU.length > 8) {
      return rawSKU.slice(0, 8);
    }
    return rawSKU.padEnd(8, '0');
  };



  useEffect(() => {
    const fetchSizeChart = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_size_chart_list`,
          { admin_auto_id, app_type_id }
        );

        if (response.data.status === "1") {
          const data = response.data.getalldata || [];

          // ✅ find normal size chart
          const normalChart = data.find(
            item => item.chart_image && item.chart_image.trim() !== ""
          );

          // ✅ find international size chart
          const internationalChart = data.find(
            item =>
              item.international_size_chart &&
              item.international_size_chart.trim() !== ""
          );

          if (normalChart) {
            setChartImage(
              `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${normalChart.chart_image}`
            );
          }

          if (internationalChart) {
            setChartImage2(
              `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${internationalChart.international_size_chart}`
            );
          }
        }
      } catch (error) {
        console.error("Failed to load size chart:", error);
      }
    };

    fetchSizeChart();
  }, [admin_auto_id, app_type_id]);


  // Prevent background scrolling when modal is open
  useEffect(() => {
    if (showSizeChart) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    // Cleanup on unmount
    return () => document.body.classList.remove("overflow-hidden");
  }, [showSizeChart]);

  const handleScroll = (direction) => {
    if (direction === "left" && startIndex > 0) {
      setStartIndex((prevIndex) => prevIndex - 1);
    } else if (direction === "right" && startIndex + 4 < allProducts.length) {
      setStartIndex((prevIndex) => prevIndex + 1);
    }
  };
  const navigate = useNavigate();

  const handleQuickView = (product) => {
    navigate(`/product-detail/${product.product_auto_id}`); // Redirect to the product detail page
  };
  const [ratings, setRatings] = useState([
    { stars: 5, count: 0 },
    { stars: 4, count: 0 },
    { stars: 3, count: 0 },
    { stars: 2, count: 0 },
    { stars: 1, count: 0 },
  ]);
  const [reviews, setReviews] = useState([]);
  const [apiLoading, setApiLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [expandedReview, setExpandedReview] = useState(null);

  const toggleReview = (index) => {
    setExpandedReview(expandedReview === index ? null : index);
  };

  // Fetch ratings and reviews from API
  useEffect(() => {
    const fetchRatings = async () => {
      setApiLoading(true);
      setApiError(null);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/Show-Ratings`,
          {
            product_auto_id: productsDetails.product_auto_id,
            admin_auto_id,
            app_type_id,
          }
        );

        if (response.data.status === 1) {
          const apiData = response.data.getalldata;

          // Calculate rating distribution
          const ratingCounts = [
            { stars: 5, count: 0 },
            { stars: 4, count: 0 },
            { stars: 3, count: 0 },
            { stars: 2, count: 0 },
            { stars: 1, count: 0 },
          ];
          apiData.forEach((item) => {
            const rating = parseInt(item.rating);
            if (rating >= 1 && rating <= 5) {
              const index = 5 - rating; // Map rating to array index (5 stars at index 0, 1 star at index 4)
              ratingCounts[index].count += 1;
            }
          });
          setRatings(ratingCounts);

          // Map API reviews to component format
          const mappedReviews = apiData.map((item) => ({
            title: item.review || "No Title", // Fallback if review is empty
            rating: parseInt(item.rating),
            text: item.review || "No review provided",
            image: item.review_image || null,
          }));
          setReviews(mappedReviews);
        } else {
          setApiError("Failed to load ratings and reviews.");
        }
      } catch (error) {
        console.error("Error fetching ratings:", error);
        setApiError("Something went wrong while loading reviews.");
      } finally {
        setApiLoading(false);
      }
    };

    fetchRatings();
  }, [productsDetails.product_auto_id, admin_auto_id, app_type_id]);

  const handleCheckPincode = async (pin) => {
    setLoading(true);
    setMessage("");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_pincode_list`,
        {
          admin_auto_id: admin_auto_id,
          user_auto_id: admin_auto_id,
        }
      );

      if (response.data.status === 1) {
        const pincodeList = response.data.get_pincode_list.map(
          (item) => item.pincode
        );
        if (pincodeList.includes(pin.trim())) {
          setMessage(`Good news! We deliver to ${pin}.`);
          setMessageColor("text-green-600");
          setPincodeAvailable(true);
        } else {
          setMessage(`Sorry, currently we are unable to deliver at ${pin}.`);
          setMessageColor("text-red-600");
        }
      } else {
        setMessage("Failed to fetch delivery data.");
        setMessageColor("text-red-600");
      }
    } catch (error) {
      console.error("Error checking pincode:", error);
      setMessage("Something went wrong. Please try again.");
      setMessageColor("text-red-600");
    } finally {
      setLoading(false);
    }
  };

  // Updated useEffect for automatic pincode checking
  useEffect(() => {
    if (pincode && pincode.length >= 6 && pincode.length <= 8) {

      handleCheckPincode(pincode);
    } else if (pincode && (pincode.length < 6 || pincode.length > 8)) {

      sessionStorage.removeItem("userPincode");
      setPincode("");
    }
  }, []); // Run only on mount

  // Updated pincode input handler
  const handlePincodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Allow only digits
    setPincode(value);
    if (value.length >= 6 && value.length <= 8) {
      handleCheckPincode(value);
    } else if ((value.length < 6 || value.length > 8) && message) {
      setMessage(""); // Clear message if pincode is invalid
      setMessageColor("");
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedImage(file);
      const reader = new FileReader();
      reader.onload = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setUploadedImage(null);
    setImagePreview(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const [uploadedImage, setUploadedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const fileInputRef = useRef(null);


  const [isBoughtFactual, setIsBoughtFactual] = useState(false);
  const [isProductViewsFactual, setIsProductViewsFactual] = useState(false);
  const [isQuantityLeftFactual, setIsQuantityLeftFactual] = useState(false);
  const [quantityLeftFactualValue, setQuantityLeftFactualValue] = useState(1);

  // State to control which messages to show
  const [showMessages, setShowMessages] = useState(false);
  const [showBought, setShowBought] = useState(false);
  const [showViews, setShowViews] = useState(false);
  const [showStock, setShowStock] = useState(false);
  const [randomStocks, setRandomStocks] = useState([]);
  const [isMarketingKeysLoading, setIsMarketingKeysLoading] = useState(true);

  useEffect(() => {
    const fetchMarketingKeys = async () => {
      setIsMarketingKeysLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_marketing_keys`,
          {
            admin_auto_id,
            app_type_id,
          }
        );

        if (response.data.status === "1" && response.data.data.length > 0) {
          const apiData = response.data.data[0];
          setIsBoughtFactual(apiData.is_bought_factual);
          setIsProductViewsFactual(apiData.is_product_views_factual);
          setIsQuantityLeftFactual(apiData.is_quantity_left_factual);
          setQuantityLeftFactualValue(apiData.quantity_left_factual_value);
        } else {
          console.error("Failed to fetch marketing keys:", response.data.msg);
        }
      } catch (error) {
        console.error("Error fetching marketing keys:", error);
      } finally {
        setIsMarketingKeysLoading(false);
      }
    };

    fetchMarketingKeys();
  }, [admin_auto_id, app_type_id]);

  useEffect(() => {
    if (isMarketingKeysLoading) {
      console.log("Waiting for marketing keys to load...");
      return;
    }

    const shouldShowMessages = Math.random() < 0.9;
    setShowMessages(shouldShowMessages);

    if (shouldShowMessages) {
      const randomChoice = Math.random();
      if (randomChoice < 0.33) {
        setShowBought(true);
        setShowViews(false);
      } else if (randomChoice < 0.66) {
        setShowBought(false);
        setShowViews(true);
      } else {
        setShowBought(true);
        setShowViews(true);
      }
    } else {
      setShowBought(false);
      setShowViews(false);
    }

    const shouldShowStock = Math.random() < 0.9;
    setShowStock(shouldShowStock);

    if (shouldShowStock) {
      const stock = parseInt(quantityLeftFactualValue, 10);

      if (isNaN(stock) || stock <= 0) {
        setRandomStocks(sizes.map(() => 0));

      } else {
        const newRandomStocks = sizes.map(() => Math.floor(Math.random() * stock) + 1);
        setRandomStocks(newRandomStocks);

      }
    } else {
      const originalStocks = sizes.map((size) => parseInt(size.size_stock, 10));
      setRandomStocks(originalStocks);

    }
  }, [productsDetails.available_stock, sizes, quantityLeftFactualValue, isMarketingKeysLoading]);



  const getRandomBoughtCount = (count) => {
    const base = parseInt(count) || 0;
    const lower = Math.floor(base * 0.8);  // -20%
    const upper = Math.ceil(base * 1.2);   // +20%
    return Math.floor(Math.random() * (upper - lower + 1)) + lower;
  };

  const getRandomViewCount = (count) => {
    const base = parseInt(count) || 0;
    const lower = Math.floor(base * 0.8);  // -20%
    const upper = Math.ceil(base * 1.2);   // +20%
    return Math.floor(Math.random() * (upper - lower + 1)) + lower;
  };

  useEffect(() => {
    if (Array.isArray(data?.product_faqs)) {
      const formattedFaqs = data.product_faqs
        .filter(item => item?.question && item?.answer)
        .map(item => ({
          question: item.question,
          answer: item.answer,
        }));

      setFaqs(formattedFaqs);
      console.log("FAQs:", faqs);

    }
  }, [data]); // 👈 VERY IMPORTANT

  return (
    <>
      <Helmet>
        {/* 🔹 Dynamic Title */}
        <title>
          {productsDetails?.product_name
            ? `${productsDetails.product_name} `
            : "Product Details"}
        </title>

        {/* 🔹 Meta Description */}
        <meta
          name="description"
          content={
            productsDetails?.description
              ? productsDetails.description
                .replace(/(<([^>]+)>)/gi, "")
              : "Buy products online at best price."
          }
        />

        {/* 🔹 Keywords */}
        <meta
          name="keywords"
          content={
            productsDetails?.keywords
              ? productsDetails.keywords
              : "online shopping, ecommerce product"
          }
        />
        {/* 🔹 PRODUCT SCHEMA (JSON-LD) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            name: productsDetails?.product_name,
            description: productsDetails?.description
              ?.replace(/(<([^>]+)>)/gi, "")
              .slice(0, 160),
            image: productsDetails?.product_images?.map(
              (img) =>
                `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${img.product_image}`
            ),
            offers: {
              "@type": "Offer",
              priceCurrency: "INR",
              price: productsDetails?.final_product_price,
              availability:
                productsDetails?.available_stock > 0
                  ? "https://schema.org/InStock"
                  : "https://schema.org/OutOfStock",
            },
          })}

        </script>
      </Helmet>
      <style>
        {`
        .no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

          @keyframes wiggle {
            0%, 100% { transform: translateX(0); }
            25% { transform: translateX(-3px); }
            50% { transform: translateX(3px); }
            75% { transform: translateX(-3px); }
          }
          .wiggle {
            animation: wiggle 0.2s ease-in-out 3;
          }

           .disabled-overlay::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 8%;
            right: 8%;
            height: 1px;
            background-color: #9ca3af; /* gray-400 */
            transform: translateY(-50%);
            pointer-events: none;
          }
        `}
      </style>
      <div className="block px-4 pt-4 bg-white md:hidden">
        <div className="flex justify-center w-full">
          <div
            className="w-full overflow-hidden bg-white cursor-zoom-in"
            onMouseMove={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const x = ((e.clientX - rect.left) / rect.width) * 100;
              const y = ((e.clientY - rect.top) / rect.height) * 100;
              e.currentTarget.children[0].style.transformOrigin = `${x}% ${y}%`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.children[0].style.transformOrigin = "center";
            }}
          >
            <img
              src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${mainImage.product_image}`}
              alt="Main Product"
              className="
          w-full
          h-[480px]
          object-cover
          cursor-pointer
        "
            />
          </div>
        </div>
      </div>


      <div id="customer-reviews" className={`w-full text-black bg-white ${webFont}`}>
        {/* Product Display Section */}

        <div className="flex flex-col gap-2 px-4 py-10 sm:px-4 lg:px-4 lg:flex-row">
          {/* Left: Image Thumbnails */}


          {/* Mobile: Horizontal Thumbnails */}
          {/* <div className="flex flex-row space-x-3 overflow-x-auto sm:hidden">
            {productImages.map((thumb) => (
              <img
                key={thumb.image_auto_id}
                src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${thumb.product_image}`}
                alt={`Thumbnail ${thumb + 1}`}
                className={`w-16 h-22 border rounded cursor-pointer flex-shrink-0
                  ${mainImage === thumb ? "border-2 border-black" : "border"}`}
                onClick={() => setMainImage(thumb)}
              />
            ))}
          </div> */}

          {/* Desktop: Vertical Thumbnails */}
          <div className="hidden sm:flex sm:flex-col sm:space-y-3">
            {productImages.map((thumb) => (
              <img
                key={thumb.image_auto_id}
                src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${thumb.product_image}`}
                alt={`Thumbnail ${thumb + 1}`}
                className={`w-24 h-22 border rounded cursor-pointer 
                  ${mainImage === thumb ? "border-2 border-black" : "border"}`}
                onClick={() => setMainImage(thumb)}
              />
            ))}
          </div>


          {/* Middle: Main Product Image */}
          <div className="flex justify-center flex-1 ">
            <div
              className="hidden overflow-hidden border rounded-2xl cursor-zoom-in md:block"
              onMouseMove={(e) => {
                const rect = e.currentTarget.getBoundingClientRect();
                const x = ((e.clientX - rect.left) / rect.width) * 100;
                const y = ((e.clientY - rect.top) / rect.height) * 100;
                e.currentTarget.children[0].style.transformOrigin = `${x}% ${y}%`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.children[0].style.transformOrigin = 'center';
              }}
            >
              <img
                src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${mainImage.product_image}`}
                alt="Main Product"
                className="object-cover h-full max-w-lg transition-transform duration-300 ease-in-out hover:scale-[2.5]"
              />
            </div>
          </div>

          {/* Right: Product Details */}
          <div className="flex-1">

            <div className="flex items-center">
              <h1 className="mr-10 text-2xl font-bold">{productsDetails.product_name}</h1>
              <button
                onClick={handleWishlistToggle}
                className={`p-1 rounded-full ${wishlisted ? "text-red-500" : "text-gray-500"
                  } ${isVibrating ? "wiggle" : ""}`}
                key={isVibrating ? `vibrate-${Date.now()}` : "no-vibrate"}
              >
                {wishlisted ? (
                  <FaHeart className="w-7 h-7" />
                ) : (
                  <FiHeart className="w-7 h-7" />
                )}
              </button>
              {/* Wishlist message right below the title line */}
              {wishlistMessage.text && (
                <div
                  className={`mt-1 text-xs ${wishlistMessage.type === "error" ? "text-red-500" : "text-green-500"
                    }`}
                >
                  {wishlistMessage.text}
                </div>
              )}
            </div>


            <div className="relative ">


            </div>
            <p className="mb-1 text-gray-500">
              SKU:{formatSKU(productsDetails.product_model_auto_id)}
            </p>
            <span
              onClick={() =>
                reviewsRef.current?.scrollIntoView({ behavior: "smooth" })
              }
              className="flex items-center no-underline cursor-pointer"
            >
              {[...Array(5)].map((_, index) =>
                index < Math.floor(avgRating) ? (
                  <FaStar key={index} className="mr-1 text-black" size={14} />
                ) : (
                  <FiStar key={index} className="mr-1 text-black" size={14} />
                )
              )}

              <span className="ml-1 text-black">
                {" "}
                {productsDetails.total_no_of_reviews} reviews
              </span>
            </span>

            <div className="mt-1">
              {showBought && isBoughtFactual && (
                <p className="flex items-center text-sm font-medium font-extrabold text-black">
                  {getRandomBoughtCount(productsDetails.bought_count)}+  bought this !
                </p>
              )}
            </div>

            <p className="text-xl font-semibold ">
              ₹{currentPrice}
              {parseInt(currentOffer) > 0 && (
                <>
                  {" "}
                  <span className="ml-1 text-gray-400 line-through">
                    ₹{originalPrice}
                  </span>
                  <span className="px-2 py-1 ml-2 text-sm text-white rounded-full"
                    style={{ backgroundColor: themeColor }}>
                    {currentOffer}% OFF
                  </span>
                </>
              )}
            </p>
            <p className="text-sm text-gray-500">
              {productsDetails.including_tax === "Yes"
                ? "Inclusive of all taxes"
                : "Exclusive of all taxes"}
            </p>
            <h3 class="border-t"></h3>

            {colors && colors.length > 0 && (
              <div className="flex flex-col mt-3 space-y-1">
                <label className="text-sm font-medium text-gray-700">
                  Color:
                </label>
                <div className="flex mt-1 space-x-2">
                  {colors.map((color) => (
                    <Link
                      to={`/product-detail/${color.product_auto_id}`}
                      key={color.product_auto_id}
                      className="w-8 h-8 border border-gray-300 rounded-full shadow-sm cursor-pointer"
                      style={{
                        backgroundColor: color.color_code
                          ? color.color_code
                            .replace("Color(0xff", "#")
                            .replace(")", "")
                          : "#000000", // Fallback color if color_code is null/undefined
                      }}
                      title={color.color_name}
                    />
                  ))}
                </div>
              </div>
            )}

            {colors && colors.length > 0 && (
              <div className="flex flex-col mt-4 space-y-2">
                <label className="text-sm font-medium text-gray-700">
                  Color:
                </label>
                <div className="flex mt-2 space-x-3">
                  {colors.map((color) => {
                    const imageUrl = color.color_image
                      ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${color.color_image}`
                      : 'https://via.placeholder.com/400x400?text=No+Image';
                    return (
                      <Link
                        to={`/product-detail/${color.product_auto_id}`}
                        key={color.product_auto_id}
                        className="
    relative overflow-hidden transition-all duration-200 border-2 shadow-md cursor-pointer
    w-16 h-28              /* desktop size */
    max-md:w-12 max-md:h-20   /* mobile size (smaller) */
  "
                        title={color.color_name}
                        onClick={() => console.log(`Attempting to load image: ${imageUrl}`)}
                        style={{ borderColor: lightenHexColor(themeColor, 0.2) }}
                        onMouseEnter={(e) => {
                          const darkenedColor = darkenHexColor(themeColor, 0.15);
                          e.currentTarget.style.borderColor = darkenedColor;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = lightenHexColor(themeColor, 0.2);
                        }}

                      >
                        <img
                          src={imageUrl}
                          alt={color.color_name || 'Color Image'}
                          className="object-cover w-full h-full"
                          onError={(e) => {
                            console.error(`Failed to load image: ${imageUrl}`);
                            e.target.src = 'https://via.placeholder.com/400x400?text=Image+Failed';
                          }}
                        />

                      </Link>
                    );
                  })}
                </div>
              </div>
            )}

            {sizes?.length > 0 && (
              <h3 className="flex items-center justify-between mt-4 space-x-4 text-gray-400 text-bold">
                <span className="text-sm ">Select </span>
                <div className="flex items-center ml-auto text-gray-500 cursor-pointer hover:text-gray-700">
                  {(chartImage || chartImage2) && (
                    <>   <button
                      className="mr-2 text-sm font-medium underline"
                      onClick={() => setShowSizeChart(true)}
                    >
                      {showSizeChart ? "Hide Size Chart" : "Size Chart"}
                    </button>
                      <FaRuler className="w-5 h-5" />
                    </>
                  )}
                </div>
              </h3>
            )}

            {showSizeChart && (
              <div className="fixed inset-0 z-50 flex items-center justify-center px-2 py-6 bg-black bg-opacity-50 sm:px-4">
                <div className="bg-white w-full max-w-3xl max-h-full overflow-y-auto rounded-lg shadow-xl relative sm:rounded-xl sm:max-h-[90vh]">
                  {/* Header */}
                  <div className="sticky top-0 z-10 flex items-center justify-between px-5 py-4 bg-white border-b">
                    <h2 className="text-xl font-semibold text-gray-800 sm:text-2xl">
                      Size Chart
                    </h2>
                    <button
                      className="p-2 text-gray-600 transition bg-gray-100 rounded-full hover:text-black hover:bg-gray-200"
                      onClick={() => setShowSizeChart(false)}
                      aria-label="Close"
                    >
                      <FaTimes size={18} />
                    </button>
                  </div>

                  {/* Content */}
                  <div className="px-5 py-4 space-y-6">
                    {/* Standard Size Chart */}
                    <div>
                      <h3 className="mb-2 text-lg font-medium text-gray-700">
                        Standard Size Chart
                      </h3>
                      {chartImage ? (
                        <img
                          src={chartImage}
                          alt="Size Chart"
                          className="w-full border border-gray-200 rounded-lg shadow-sm"
                        />
                      ) : (
                        <p className="text-sm text-gray-500">
                          Chart image not available.
                        </p>
                      )}
                    </div>

                    {/* International Size Chart */}
                    <div>
                      <h3 className="mb-2 text-lg font-medium text-gray-700">
                        International Size Chart
                      </h3>
                      {chartImage2 ? (
                        <img
                          src={chartImage2}
                          alt="International Size Chart"
                          className="w-full border border-gray-200 rounded-lg shadow-sm"
                        />
                      ) : (
                        <p className="text-sm text-gray-500">
                          International chart image not available.
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* <div className="flex mt-4 space-x-2">
              {sizes.map((size, index) => (
                <button
                  key={size.product_auto_id}
                  className={`border px-3 py-1 rounded-full text-white text-xl bg-gray-400 w-10 h-10 flex items-center justify-center ${selectedSize === size.size_name
                    ? "border-2  "
                    : ""
                    }`}
                    style={{backgroundColor:selectedSize === size.size_name ? themeColor : "" ,borderColor:selectedSize === size.size_name ? themeColor : ""}}
                  onClick={() => handleSizeSelect(size, index)}
                >
                  {size.size_name}
                </button>
              ))}
            </div>  */}

            <div className="flex mt-4 space-x-2">
              {sizes.map((size, index) => {
                const actualStock = parseInt(size.size_stock, 10);
                const isDisabled = !actualStock || isNaN(actualStock) || actualStock <= 0;
                const isSelected = selectedSize === size.size_name;

                const displayStock = showStock ? randomStocks[index] : actualStock;
                const showStockLabel =
                  actualStock > 0 && showStock && isQuantityLeftFactual && displayStock <= 5;

                return (
                  <div key={size.product_auto_id} className="relative">
                    <button
                      className={`relative border w-20 h-12 max-md:w-14 max-md:h-10 max-md:text-xs rounded-full text-sm flex items-center justify-center flex-col transition-colors duration-200 overflow-hidden
            ${isDisabled ? "bg-gray-200 text-gray-400 border-gray-300 cursor-not-allowed" : ""}
            ${!isDisabled && isSelected ? "text-white" : ""}
          `}
                      style={{
                        backgroundColor: !isDisabled && isSelected ? themeColor : undefined,
                        borderColor: !isDisabled && isSelected ? themeColor : undefined,
                        color: !isDisabled && isSelected ? "#ffffff" : undefined,
                        position: "relative",
                      }}
                      onClick={() => !isDisabled && handleSizeSelect(size, index)}
                      onMouseEnter={(e) => {
                        if (!isSelected && !isDisabled) {
                          e.currentTarget.style.backgroundColor = themeColor;
                          e.currentTarget.style.color = "#ffffff";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected && !isDisabled) {
                          e.currentTarget.style.backgroundColor = "#ffffff";
                          e.currentTarget.style.color = "#000000";
                        }
                      }}
                      disabled={isDisabled}
                    >
                      {/* SIZE LABEL */}
                      <span
                        className={`text-base leading-none ${showStockLabel ? "mb-3" : ""}`}
                      >
                        {size.size_name}
                      </span>

                      {/* STOCK LABEL */}
                      {showStockLabel && (
                        <span
                          className="absolute bottom-0 left-0 right-0 px-2 py-[4px] text-[11px] text-center text-white leading-tight"
                          style={{ backgroundColor: themeColor }}
                        >
                          {displayStock} left
                        </span>
                      )}

                      {/* CROSS LINES FOR DISABLED BUTTON */}
                      {isDisabled && (
                        <>
                          <span
                            className="absolute w-[130%] h-[1px] bg-gray-400 left-1/2 top-1/2"
                            style={{
                              transform: "translate(-50%, -50%) rotate(35deg)",
                            }}
                          ></span>


                        </>
                      )}
                    </button>
                  </div>
                );
              })}
            </div>



            <div className="mt-4">
              <p className="flex items-center font-semibold text-gray-500">
                <FaMapMarkerAlt className="mr-2" size={18} /> Check Availability
              </p>
              <div className="flex items-center mt-2">
                <input
                  type="text"
                  placeholder="Enter pincode"
                  value={pincode}
                  onChange={handlePincodeChange}
                  className="w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                  maxLength={8} // Allow up to 8 digits
                  disabled={loading}
                />
              </div>
              {loading && (
                <p className="mt-2 text-sm font-medium text-gray-600">
                  Checking...
                </p>
              )}
              {message && (
                <p
                  className={`mt-2 text-sm font-medium ${messageColor}  p-2 `}
                >
                  {message}
                </p>
              )}
            </div>

            {isCustomizable && (
              <div className="mt-4">
                <p className="flex items-center font-semibold text-gray-500">
                  <span className="mr-2">📷</span> Customize Your Product
                </p>
                <div className="p-4 mt-2 border border-gray-300 rounded-lg bg-gray-50">
                  <p className="mb-2 text-sm text-gray-600">
                    Upload an image to personalize your{" "}
                    {productsDetails.product_name}
                  </p>
                  <div className="flex items-center gap-4">
                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      onChange={handleImageUpload}
                      className="hidden"
                      id="image-upload"
                    />
                    <label
                      htmlFor="image-upload"
                      className="px-4 py-2 text-white transition duration-200 rounded-lg cursor-pointer "
                      style={{ backgroundColor: themeColor }}
                      onMouseEnter={(e) => {
                        const darkenedColor = lightenHexColor(themeColor, 0.1);
                        e.currentTarget.style.backgroundColor = darkenedColor;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = themeColor;
                      }}
                    >
                      Choose Image
                    </label>
                    {imagePreview && (
                      <div className="flex items-center gap-2">
                        <img
                          src={imagePreview}
                          alt="Preview"
                          className="object-cover w-16 h-16 border border-gray-300 rounded-md"
                        />
                        <button
                          onClick={handleRemoveImage}
                          className="p-1 text-red-500 transition bg-gray-100 rounded-full hover:text-red-700 hover:bg-gray-200"
                          aria-label="Remove uploaded image"
                        >
                          <FaTimes size={16} />
                        </button>
                      </div>
                    )}
                  </div>
                  {uploadedImage && (
                    <p className="mt-2 text-sm text-green-600">
                      Image uploaded: {uploadedImage.name}
                    </p>
                  )}
                  <p className="mt-2 text-xs text-gray-500">
                    Supported formats: JPG, PNG, GIF.
                  </p>
                </div>
              </div>
            )}
            <div className="relative mt-4">
              {cartMessage.text && (
                <div
                  className={`absolute left-0 right-0 top-[-2rem] text-center p-2 text-sm ${cartMessage.type === "error" ? "text-red-500" : "text-green-500"
                    }`}
                >
                  {cartMessage.text}
                </div>
              )}
              <button
                className={`w-full py-2 rounded-full font-semibold transition-colors duration-200 
                    ${sizes?.length > 0 && !selectedSize
                    ? "bg-gray-400 text-white cursor-not-allowed"
                    : "text-white cursor-pointer"
                  }`}
                style={{
                  backgroundColor: sizes?.length > 0 && !selectedSize ? "#ccc" : themeColor,
                }}
                onMouseEnter={(e) => {
                  if (!(sizes?.length > 0 && !selectedSize)) {
                    const darkenedColor = lightenHexColor(themeColor, 0.1);
                    e.currentTarget.style.backgroundColor = darkenedColor;
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor =
                    sizes?.length > 0 && !selectedSize ? "#ccc" : themeColor;
                }}
                onClick={async () => {
                  if (sizes?.length > 0 && !selectedSize) {
                    setCartMessage({ text: "Select a Size", type: "error" });
                    return;
                  }
                  if (sizes?.length > 0 && selectedStock === 0) {
                    setCartMessage({ text: "Selected size is out of stock", type: "error" });
                    return;
                  }
                  try {
                    const payload = {
                      product_auto_id: productsDetails?.product_auto_id,
                      added_by_id: productsDetails?.user_auto_id,
                      cart_quantity:
                        productsDetails?.moq && productsDetails.moq !== ""
                          ? productsDetails.moq
                          : 1,
                      ...(sizes?.length !== 0 && {
                        size: selectedSizeId,
                        size_price: currentPrice,
                      }),
                      ...(isCustomizable && uploadedImage && { cust_image: uploadedImage }),
                    };
                    const res = await addToCart(payload);
                    setCartMessage({ text: res.message, type: res.status === "1" ? "success" : "error" });
                    if (res.status === "1") {
                      setTimeout(() => {
                        navigate("/cart");
                      }, 1000);
                    }
                  } catch (error) {
                    setCartMessage({ text: error.message || "Failed to add product to cart.", type: "error" });
                  }
                }}
                disabled={sizes?.length > 0 && !selectedSize}
              >
                {sizes?.length > 0 && !selectedSize
                  ? "Select a Size"
                  : sizes?.length > 0 && selectedStock === 0
                    ? "Size Out of Stock"
                    : `Add to Cart | ₹ ${currentPrice}`}
              </button>

              <div className="mt-2 space-y-2">
                {showViews && isProductViewsFactual && (
                  <p className="flex items-center justify-center text-sm font-medium text-black">
                    <IoEyeSharp className="mr-1" size={18} />
                    {getRandomViewCount(productsDetails.view_count)} people are viewing this item. Don’t wait!
                  </p>
                )}
              </div>


            </div>
            <div className="mt-4">
              <h3 className="text-gray-500 text-bold">Service Policy</h3>
              <ul className="pl-5 text-black list-disc">
                <li>Cash on delivery available in most areas</li>
                <li>Easy Shipping</li>
                <li>Secure Payments</li>
                <li>Online payments only</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Product Details & Exchange Tabs */}
        <div className="w-full mx-auto text-white bg-black max-w-7xl">

          {/* Mobile View Dropdown */}
          <div className="w-full px-3 py-3 border-t border-b border-gray-600 md:hidden">

            {/* Product Details */}
            <div className="w-full py-2 text-gray-300 cursor-pointer" onClick={() => toggleSection("productDetails")}>
              <div className="flex items-center justify-between">
                <span className="font-semibold">Product Details</span>
                {activeSection === "productDetails" ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
              </div>

              {activeSection === "productDetails" && (
                <div className="p-3 mt-3 text-black bg-gray-300 rounded-lg">
                  <p className="font-semibold">ALSO AVAILABLE IN</p>
                  <p className="mb-2 font-semibold underline">{productsDetails.color_name}</p>

                  {productSpecification.map((section) => (
                    <div key={section.title}>
                      <p className="mt-3 font-semibold">{section.title}</p>
                      <p>{section.description}</p>
                    </div>
                  ))}

                  <p className="mt-3 font-semibold">Description</p>
                  <p>{productsDetails.description}</p>

                  <p className="mt-3 font-semibold">Product Care</p>
                  <ul className="list-disc list-inside">
                    <li>Wash separately</li>
                    <li>Do not dry clean</li>
                    <li>Do not bleach</li>
                    <li>No machine wash</li>
                    <li>Wash cold</li>
                  </ul>
                </div>
              )}
            </div>

            {/* Specification */}
            <div className="w-full py-2 text-gray-300 cursor-pointer" onClick={() => toggleSection("specification")}>
              <div className="flex items-center justify-between">
                <span className="font-semibold">Specification</span>
                {activeSection === "specification" ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
              </div>

              {activeSection === "specification" && (
                <div className="p-3 mt-3 text-black bg-gray-300 rounded-lg">
                  {productSpecification.map((item, index) => (
                    <div key={index} className="mb-2">
                      <p className="text-xs text-gray-500">{item.title}</p>
                      <p className="font-medium">{item.description}</p>
                      <hr className="my-2 border-gray-500" />
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Return / Exchange */}
            <div className="w-full py-2 text-gray-300 cursor-pointer" onClick={() => toggleSection("returnExchange")}>
              <div className="flex items-center justify-between">
                <span className="font-semibold">Return / Exchange</span>
                {activeSection === "returnExchange" ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
              </div>

              {activeSection === "returnExchange" && (
                <div className="p-3 mt-3 text-black bg-gray-300 rounded-lg">
                  <p className="mb-2">
                    We offer a <span className="font-bold">7-day no-questions-asked return/exchange policy</span>.
                  </p>
                  <ul className="list-disc list-inside">
                    <li>No returns for products below INR 1,000.</li>
                    <li>One-time return for products above INR 1,700.</li>
                    <li>COD refunds issued via Gift Card.</li>
                  </ul>
                </div>
              )}
            </div>
          </div>


          {/* Desktop Tabs Section */}
          <div className="justify-between hidden px-3 py-3 border-t border-b border-gray-600 md:flex md:px-96">

            <div className="flex items-center text-gray-400 cursor-pointer hover:text-gray-200" onClick={() => toggleSection("productDetails")}>
              <span className="text-base font-semibold">Product Details</span>
              {activeSection === "productDetails" ? <ChevronUp size={16} className="ml-2" /> : <ChevronDown size={16} className="ml-2" />}
            </div>

            <div className="w-px h-6 bg-gray-600" />

            <div className="flex items-center text-gray-400 cursor-pointer hover:text-gray-200" onClick={() => toggleSection("specification")}>
              <span className="text-base font-semibold">Specification</span>
              {activeSection === "specification" ? <ChevronUp size={16} className="ml-2" /> : <ChevronDown size={16} className="ml-2" />}
            </div>

            <div className="w-px h-6 bg-gray-600" />

            <div className="flex items-center text-gray-400 cursor-pointer hover:text-gray-200" onClick={() => toggleSection("returnExchange")}>
              <span className="text-base font-semibold">Return/Exchange</span>
              {activeSection === "returnExchange" ? <ChevronUp size={16} className="ml-2" /> : <ChevronDown size={16} className="ml-2" />}
            </div>
          </div>


          {/* Desktop Content */}
          {activeSection === "productDetails" && (
            <div className="hidden p-6 text-black bg-gray-300 md:block">
              <p className="font-semibold">ALSO AVAILABLE IN</p>
              <p className="mb-2 font-semibold underline">{productsDetails.color_name}</p>

              {productSpecification.map((section) => (
                <div key={section.title}>
                  <p className="mt-3 font-semibold">{section.title}</p>
                  <p className="mb-2">{section.description}</p>
                </div>
              ))}

              <p className="mt-3 font-semibold">Description</p>
              <p className="mb-2">{productsDetails.description}</p>

              <p className="mt-3 font-semibold">Product Care</p>
              <ul className="list-disc list-inside">
                <li>Wash separately</li>
                <li>Do not dry clean</li>
                <li>Do not bleach</li>
                <li>No machine wash</li>
                <li>Wash cold</li>
              </ul>
            </div>
          )}

          {activeSection === "specification" && productSpecification.length > 0 && (
            <div className="hidden p-6 text-black bg-gray-300 md:block">
              <div className="grid grid-cols-2 gap-4 pl-16">
                {productSpecification.map((product, index) => (
                  <div key={index} className="flex flex-col">
                    <span className="text-sm text-gray-500">{product.title}</span>
                    <span className="text-base font-medium">{product.description}</span>
                    {index !== productSpecification.length - 1 && <hr className="my-2 border-gray-500" />}
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeSection === "returnExchange" && (
            <div className="hidden p-6 text-black bg-gray-300 md:block">
              <p className="mb-2">
                We offer a <span className="font-bold">7-day no-questions-asked return/exchange policy</span> for both Prepaid and COD orders above INR 1,700.
              </p>
              <ul className="list-disc list-inside">
                <li>Returns/exchanges are <span className="font-bold">not permitted</span> for products below INR 1,000.</li>
                <li>Products priced above INR 1,700 are eligible for a single return via Gift Card (GC).</li>
                <li>Refunds for COD orders will only be issued through a Gift Card.</li>
              </ul>
            </div>
          )}
        </div>


        {/* Similar Products Section */}
        <div className="relative py-10 mx-auto max-w-7xl">
          <h2 className="text-xl font-bold text-center">SIMILAR PRODUCTS</h2>

          {/* Product List */}
          <div className="relative overflow-hidden">

            {/* MOBILE → SLIDER (horizontal scroll) */}
            <div className="flex gap-1 mt-6 overflow-x-auto scrollbar-hide md:hidden">
              {visibleProducts.map((product) => (
                <Link
                  to={`/product-detail/${product.product_auto_id}`}
                  className="no-underline text-inherit min-w-[50%] max-w-[75%]"
                >
                  <div
                    key={product.product_auto_id}
                    className="relative group"
                    id="similar-products"
                  >
                    <div className="relative overflow-hidden rounded-md shadow-md">
                      <div className="relative">

                        {product.offer_percentage > 0 && (
                          <div
                            className="absolute px-2 py-1 text-xs font-bold text-white rounded-md top-2 left-2"
                            style={{ backgroundColor: themeColor }}
                          >
                            {product.offer_percentage}% OFF
                          </div>
                        )}

                        <img
                          src={
                            product.product_images?.[0]?.product_image
                              ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${product.product_images[0].product_image}`
                              : "https://placehold.co/300x400"
                          }
                          alt={product.product_name}
                          className="w-full h-[300px] rounded-md object-cover"
                        />

                      </div>
                    </div>

                    <p className="mt-2 mb-0 text-sm text-center">
                      {product.product_name.length > 18
                        ? `${product.product_name.slice(0, 18)}...`
                        : product.product_name}
                    </p>

                    <p className="text-sm text-center text-gray-700">
                      <span className="mr-4 font-bold">
                        Rs. {product.final_product_price}
                      </span>
                      {product.offer_percentage > 0 && (
                        <span className="text-gray-500 line-through">
                          Rs. {product.product_price}
                        </span>
                      )}
                    </p>
                  </div>
                </Link>
              ))}
            </div>

            {/* DESKTOP → ORIGINAL GRID (unchanged) */}
            <div className="hidden grid-cols-2 gap-4 mt-6 md:grid md:grid-cols-4">
              {visibleProducts.map((product) => (
                <Link
                  to={`/product-detail/${product.product_auto_id}`}
                  className="no-underline text-inherit"
                >
                  <div
                    key={product.product_auto_id}
                    className="relative group"
                    id="similar-products"
                  >
                    <div className="relative overflow-hidden rounded-md shadow-md">
                      <div className="relative">

                        {product.offer_percentage > 0 && (
                          <div
                            className="absolute px-2 py-1 text-xs font-bold text-white rounded-md top-2 left-2"
                            style={{ backgroundColor: themeColor }}
                          >
                            {product.offer_percentage}% OFF
                          </div>
                        )}

                        <img
                          src={
                            product.product_images?.[0]?.product_image
                              ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${product.product_images[0].product_image}`
                              : "https://placehold.co/300x400"
                          }
                          alt={product.product_name}
                          className="w-full h-[300px] rounded-md object-cover"
                        />

                      </div>
                    </div>

                    <p className="mt-2 mb-0 text-sm text-center md:text-base">
                      {product.product_name.length > 18
                        ? `${product.product_name.slice(0, 18)}...`
                        : product.product_name}
                    </p>

                    <p className="text-sm text-center text-gray-700 md:text-base">
                      <span className="mr-4 font-bold">
                        Rs. {product.final_product_price}
                      </span>
                      {product.offer_percentage > 0 && (
                        <span className="text-gray-500 line-through">
                          Rs. {product.product_price}
                        </span>
                      )}
                    </p>

                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* Desktop Navigation Buttons → unchanged */}
          {allProducts.length > 4 && (
            <>
              {startIndex > 0 && (
                <button
                  onClick={() => handleScroll("left")}
                  className="absolute z-10 hidden p-2 text-white transform -translate-y-1/2 rounded-full shadow-md left-2 top-1/2 sm:p-3 md:block"
                  style={{ backgroundColor: themeColor }}
                >
                  <ChevronLeft size={20} />
                </button>
              )}

              {startIndex + 4 < allProducts.length && (
                <button
                  onClick={() => handleScroll("right")}
                  className="absolute z-10 hidden p-2 text-white transform -translate-y-1/2 rounded-full shadow-md right-2 top-1/2 sm:p-3 md:block"
                  style={{ backgroundColor: themeColor }}
                >
                  <ChevronRight size={20} />
                </button>
              )}
            </>
          )}
        </div>


        {crossSellingProducts.length > 0 && (
          <div className="relative py-10 mx-auto max-w-7xl">
            <h2 className="text-xl font-bold text-center">YOU MAY ALSO BUY</h2>
            {crossSellingLoading ? (
              <p className="mt-4 text-lg text-center text-gray-600">Loading products...</p>
            ) : (
              <div className="relative overflow-hidden">
                <div className="grid grid-cols-2 gap-4 mt-6 md:grid-cols-4">
                  {crossSellingProducts.slice(crossSellingStartIndex, crossSellingStartIndex + 4).map((product) => (
                    <Link to={`/product-detail/${product.product_auto_id}`} className="no-underline text-inherit" key={product.product_auto_id}>
                      <div className="relative group">
                        <div className="relative overflow-hidden rounded-md shadow-md">
                          <div className="relative">
                            {product.offer_percentage > 0 && (
                              <div className="absolute px-2 py-1 text-xs font-bold text-white rounded-md top-2 left-2" style={{ backgroundColor: themeColor }}>
                                {product.offer_percentage}% OFF
                              </div>
                            )}
                            {product.product_images.length > 0 && (
                              <img
                                src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${product.product_images[0].product_image}`}
                                alt={product.product_name}
                                onError={(e) => (e.target.src = "/image/fallback.webp")}
                                className="w-full h-[300px] rounded-md object-cover"
                              />
                            )}
                            <button
                              className="absolute hidden w-32 py-2 text-white transition-opacity duration-300 ease-in-out rounded-lg cursor-pointer md:w-64 bottom-4 left-5 group-hover:block"
                              onClick={() => handleQuickView(product.product_auto_id)}
                              style={{ backgroundColor: themeColor }}
                              onMouseEnter={(e) => {
                                const lightenColor = lightenHexColor(themeColor, 0.1);
                                e.currentTarget.style.backgroundColor = lightenColor;
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = themeColor;
                              }}
                            >
                              Quick View
                            </button>
                          </div>
                        </div>
                        <p className="mt-2 mb-0 text-sm text-center md:text-base">
                          {product.product_name.length > 18 ? `${product.product_name.slice(0, 18)}...` : product.product_name}
                        </p>
                        <p className="text-sm text-center text-gray-700 md:text-base">
                          <span className="mr-4 font-bold">Rs. {product.final_product_price}</span>
                          {product.offer_percentage > 0 && (
                            <span className="text-gray-500 line-through">Rs. {product.product_price}</span>
                          )}
                        </p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )}
            {crossSellingProducts.length > 4 && (
              <>
                {crossSellingStartIndex > 0 && (
                  <button
                    onClick={() => handleScroll("left", true)}
                    className="absolute z-10 p-2 text-white transform -translate-y-1/2 rounded-full shadow-md left-2 top-1/2 sm:p-3"
                    style={{ backgroundColor: themeColor }}
                    onMouseEnter={(e) => {
                      const lightenColor = lightenHexColor(themeColor, 0.1);
                      e.currentTarget.style.backgroundColor = lightenColor;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = themeColor;
                    }}
                  >
                    <ChevronLeft size={20} />
                  </button>
                )}
                {crossSellingStartIndex + 4 < crossSellingProducts.length && (
                  <button
                    onClick={() => handleScroll("right", true)}
                    className="absolute z-10 p-2 text-white transform -translate-y-1/2 rounded-full shadow-md right-2 top-1/2 sm:p-3"
                    style={{ backgroundColor: themeColor }}
                    onMouseEnter={(e) => {
                      const lightenColor = lightenHexColor(themeColor, 0.1);
                      e.currentTarget.style.backgroundColor = lightenColor;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = themeColor;
                    }}
                  >
                    <ChevronRight size={20} />
                  </button>
                )}
              </>
            )}
          </div>
        )}

        {/* Customer Reviews Section */}
        <div
          ref={reviewsRef}
          id="customer-reviews"
          className="p-4 mx-auto bg-white rounded-lg shadow-md max-w-7xl"
        >
          <h2 className="text-2xl font-bold text-center sm:text-3xl">Ratings & Reviews</h2>
          <hr></hr>

          {apiLoading ? (
            <p className="mt-4 text-lg text-center text-gray-600">Loading ratings...</p>
          ) : apiError ? (
            <p className="mt-4 text-lg text-center text-red-600">{apiError}</p>
          ) : (
            <>
              {/* Rating Summary */}
              <div className="flex flex-col mt-4 sm:flex-row sm:items-start sm:gap-10 sm:ml-8">
                {/* Average Rating Summary */}
                <div className="text-center sm:text-left sm:w-1/3">
                  <p className="text-lg font-semibold">{avgRating}/5</p>
                  <p className="text-lg font-bold">
                    {[...Array(5)].map((_, index) =>
                      index < Math.floor(avgRating) ? "★" : "☆"
                    )}
                  </p>
                  <p className="mt-1 text-sm font-medium text-black">
                    {ratings.reduce((sum, r) => sum + r.count, 0)} star ratings,{" "}
                    {productsDetails.total_no_of_reviews} reviews
                  </p>
                </div>

                {/* Rating Bars */}
                <div className="mt-6 space-y-3 sm:mt-0 sm:w-2/3">
                  {ratings.map((rating) => (
                    <div key={rating.stars} className="flex items-center">
                      <span className="w-16 text-sm font-medium text-black">
                        {rating.stars} Stars
                      </span>
                      <div className="flex-1 h-3 mx-2 overflow-hidden bg-gray-300 rounded-lg">
                        <div
                          className="h-full transition-all duration-300 ease-in-out bg-black"
                          style={{
                            width: `${rating.count > 0
                              ? (rating.count /
                                ratings.reduce((sum, r) => sum + r.count, 0)) *
                              100
                              : 0
                              }%`,
                          }}
                        />
                      </div>
                      <span className="w-6 text-sm font-medium text-black">
                        {rating.count}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Most Helpful Reviews */}
              <h3 className="mt-10 text-lg font-bold text-center sm:text-left sm:ml-8">
                Most Helpful Reviews
              </h3>

              <div className="grid grid-cols-1 gap-4 mt-4 sm:grid-cols-2 md:grid-cols-3">
                {reviews.length > 0 ? (
                  reviews.slice(0, 6).map((review, index) => (
                    <div
                      key={index}
                      className="p-4 transition-all duration-300 border rounded-lg"
                    >
                      <h4 className="font-semibold">
                        {review.title}{" "}
                        {[...Array(review.rating)].map((_, idx) => (
                          <FaStar key={idx} className="inline-block text-black" size={14} />
                        ))}
                      </h4>

                      <p className="mt-2 text-sm text-gray-600">
                        {expandedReview === index
                          ? review.text
                          : review.text.split(/\s+/).slice(0, 20).join(" ")}
                        {review.wordCount > 20 && expandedReview !== index && "..."}
                      </p>

                      {review.image && (
                        <img
                          src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/RatingReview/${review.image}`}
                          alt="Review Image"
                          className="object-cover w-full h-auto mt-2 rounded-md max-h-48"
                          onError={(e) => (e.target.src = "/image/fallback.webp")}
                        />
                      )}

                      {review.wordCount > 20 && (
                        <p
                          className="mt-2 text-sm font-semibold text-black underline cursor-pointer"
                          onClick={() => toggleReview(index)}
                        >
                          {expandedReview === index ? "Collapse" : "Full Review"}
                        </p>
                      )}
                    </div>
                  ))
                ) : (
                  <p className="text-gray-600">No reviews available.</p>
                )}
              </div>
            </>
          )}
        </div>

      </div>
      {faqs.length > 0 && (
        <section className="faq-section">
          <h2 className="faq-title">Frequently Asked Questions</h2>

          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <h3 className="faq-question">{faq.question}</h3>
              <p className="faq-answer">{faq.answer}</p>
            </div>
          ))}
        </section>
      )}

      {faqs.length > 0 && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: faqs.map(faq => ({
                "@type": "Question",
                name: faq.question,
                acceptedAnswer: {
                  "@type": "Answer",
                  text: faq.answer,
                },
              })),
            }),
          }}
        />
      )}
    </>
  );
};

export default ProductDetail0;